export const NewtonView = {
  EMBED: 'embed',
  PICKER: 'picker',
  NOT_CONFIGURED: 'not-configured'
} as const;
export type NewtonViewType = (typeof NewtonView)[keyof typeof NewtonView];

// Which of the three Newton states to render. Mapped clients (a non-empty project slug) always
// embed; unmapped clients show the picker to internal users and a "not configured" state to
// everyone else.
export const resolveNewtonView = (
  projectSlug: string | null | undefined,
  isInternal: boolean
): NewtonViewType => {
  if (projectSlug) return NewtonView.EMBED;
  if (isInternal) return NewtonView.PICKER;
  return NewtonView.NOT_CONFIGURED;
};

// The picker collects just the URL slug segment (between /project/ and /home) — a Newton
// project id or name. Valid slugs are a single non-empty path segment (no slashes/whitespace).
export const isValidNewtonSlug = (slug: string): boolean => /^[^/\s]+$/.test(slug.trim());
